export const DEFAULT_DRIVER_STATUS_ACTIONS = {
  "-2": "manageDriverStatus_clockIn",
  "-1": "manageDriverStatus_clockOut",
  "-3": "manageDriverStatus_mealBreakBegin",
  "-4": "manageDriverStatus_mealBreakEnd"
};

export const DEFAULT_DRIVER_STATUS_NAME = {
  I: "manageDriverStatus_clockIn",
  O: "manageDriverStatus_clockOut",
  BI: "manageDriverStatus_mealBreakBegin",
  BO: "manageDriverStatus_mealBreakEnd"
};

export const DEFAULT_DRIVER_STATUS_NAME_REVERSE = {
  "manageDriverStatus_clockIn": "I",
  "manageDriverStatus_clockOut": "O",
  "manageDriverStatus_mealBreakBegin": "BI",
  "manageDriverStatus_mealBreakEnd": "BO"
};

export const likeSimple = (text, pattern) => {
  if (!text || !pattern) return '';
  return pattern.toLowerCase().includes(text.toLowerCase());
}

export const searchDriverStatusKey = (text, messages) => {
  const buildArray = []
  if (likeSimple(text, messages["manageDriverStatus_clockIn"])) {
    buildArray.push(DEFAULT_DRIVER_STATUS_NAME_REVERSE["manageDriverStatus_clockIn"])
  }
  if (likeSimple(text, messages["manageDriverStatus_clockOut"])) {
    buildArray.push(DEFAULT_DRIVER_STATUS_NAME_REVERSE["manageDriverStatus_clockOut"])
  }
  if (likeSimple(text, messages["manageDriverStatus_mealBreakBegin"])) {
    buildArray.push(DEFAULT_DRIVER_STATUS_NAME_REVERSE["manageDriverStatus_mealBreakBegin"])
  }
  if (likeSimple(text, messages["manageDriverStatus_mealBreakEnd"])) {
    buildArray.push(DEFAULT_DRIVER_STATUS_NAME_REVERSE["manageDriverStatus_mealBreakEnd"])
  }
  return [
    text,
    ...buildArray
  ]
}
